export interface NotifyMessage {
    detail: {
        message: string;
        type: 'error' | 'success';
    };
}

const notify = {
    error: (errorMessage: string) => {
        const message: NotifyMessage = {
            detail: {
                message: errorMessage,
                type: 'error',
            },
        };
        const event = new CustomEvent('notify', message);
        document.dispatchEvent(event);
    },
    success: (successMessage: string) => {
        const message: NotifyMessage = {
            detail: {
                message: successMessage,
                type: 'success',
            },
        };
        const event = new CustomEvent('notify', message);
        document.dispatchEvent(event);
    },
};

export default notify;
